import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  modalView: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    width: 405,
    height: 570,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 18,
    padding: 32,
  },

  items: {
    flex: 1,
    width: "100%",
    overflowY: "auto",
    marginBottom: 20,
  },

  item: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 15,
  },

  footer: {
    display: "flex",
    width: "100%",
    "& span": {
      fontSize: 18,
      fontWeight: "bold",
    },
  },

  actions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  collunName: {
    display: "flex",
    flexDirection: "column",
  },

  ownerName: {
    fontSize: 16,
    fontWeight: "bold",
    marginLeft: 16,
    width: 175,
  },

  ownerEnrollment: {
    fontSize: 10,
    marginLeft: 16,
    width: 175,
  },

  filterWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    width: '100%',
    marginBottom: 30,
    alignItems: "center",
    justifyContent: "center",
  },

  line: {
    borderTop: 0.2,
    width: '100%',
    borderColor: '#C1C1C5',
    marginBottom: 20,
  },

}));

export default useStyles;
